import { render, staticRenderFns } from "./SimpleSkill.vue?vue&type=template&id=a7658a84&scoped=true"
import script from "./SimpleSkill.vue?vue&type=script&lang=js"
export * from "./SimpleSkill.vue?vue&type=script&lang=js"
import style0 from "./SimpleSkill.vue?vue&type=style&index=0&id=a7658a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7658a84",
  null
  
)

export default component.exports